import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import {
  fetchNotifications,
  fetchUnreadCount,
  markAsRead,
  markAllAsRead,
} from '../store/slices/notificationSlice';

const useNotifications = () => {
  const dispatch = useDispatch();
  const { notifications, unreadCount, loading, totalCount } = useSelector(
    (state) => state.notification
  );
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  // Poll unread count every 30 seconds
  useEffect(() => {
    if (!isAuthenticated) return;
    dispatch(fetchUnreadCount());
    const interval = setInterval(() => {
      dispatch(fetchUnreadCount());
    }, 30000);
    return () => clearInterval(interval);
  }, [dispatch, isAuthenticated]);

  const loadNotifications = useCallback(
    (params) => dispatch(fetchNotifications(params)),
    [dispatch]
  );

  const handleMarkAsRead = useCallback(
    (id) => dispatch(markAsRead(id)),
    [dispatch]
  );

  const handleMarkAllAsRead = useCallback(
    () => dispatch(markAllAsRead()),
    [dispatch]
  );

  return {
    notifications,
    unreadCount,
    loading,
    totalCount,
    loadNotifications,
    markAsRead: handleMarkAsRead,
    markAllAsRead: handleMarkAllAsRead,
  };
};

export default useNotifications;
